import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-attachments-pill',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './attachments-pill.component.html',
  styleUrl: './attachments-pill.component.scss'
})
export class AttachmentsPillComponent {
  @Input() count: number = 0;
  @Output() pillClick = new EventEmitter<void>();

  get labelKey(): string {
    return this.count === 1 ? 'accidents.attachments.countOne' : 'accidents.attachments.countOther';
  }
}